const v1 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        topScriptTopicsTable: {
          ...state.options.tableViews.topScriptTopicsTable,
          "Total views": true,
        },
        topThumbTopicsTable: {
          ...state.options.tableViews.topThumbTopicsTable,
          "Total views": true,
        },
        topTitleTopicsTable: {
          ...state.options.tableViews.topTitleTopicsTable,
          "Total views": true,
        },
        topVideoTypesTable: {
          ...state.options.tableViews.topVideoTypesTable,
          "Total views": true,
        },
      },
    },
  };
};

export default v1;
